import { createContentHook } from './createContentHook';
import { SalesAndResourcesDistributorPortalsContent } from '../types/SalesAndResourcesDistributorPortals';

export const useSalesAndResourcesDistributorPortalsContent =
    createContentHook<SalesAndResourcesDistributorPortalsContent>(
        '/SalesAndResources/DistributorPortals'
    );
